// ABOUTME: Shared CPQ types. Single source of truth for the MODEL.item_type discriminator.
// ABOUTME: Use ItemType / ITEM_TYPE everywhere item_type is referenced instead of raw string literals.

export const ITEM_TYPE = { product: 'product', service: 'service' } as const;

export type ItemType = (typeof ITEM_TYPE)[keyof typeof ITEM_TYPE];
